import actions from "./actions";
import axiosServices from '@services/axiosServices'
import { API_HOST, API } from "@configs/api";
import actionsAlert from "../alert/actions";

const { getAllCandidature, getAllProposedCandidate } = actions;
const { alert } = actionsAlert;

const getAllCandidatures = (data, page) => {
    const URL = API_HOST + API.candidature.allCandidature;
    return async dispatch => {
        axiosServices.post(URL, data, { params: page }).then(
            (res) => {
                dispatch(getAllCandidature(res.data));
            },
            (err) => {
                console.log(err);
            }
        )
    }
}

const getAllProposedCandidates = (data, page) => {
    const URL = API_HOST + API.candidature.proposedCandidate;
    return async dispatch => {
        axiosServices.post(URL, data, { params: page }).then(
            (res) => {
                dispatch(getAllProposedCandidate(res.data))
            },
            (err) => {
                console.log(err);
            }
        )
    }
}

const cancelCandidature = (data, dataSearch, page, onClose) => {
    const URL = API_HOST + API.candidature.cancelCandidature + data.id;
    return async dispatch => {
        axiosServices.delete(URL).then(
            (res) => {
                onClose();
                dispatch(getAllCandidatures(dataSearch, page))
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }))
            }
        )
    }
}

const handlingNotinterrested = (data, dataSearch, page) => {
    const URL = API_HOST + API.favorite.handleFavourites;
    return async dispatch => {
        axiosServices.post(URL, data).then((res) => {
            dispatch(getAllProposedCandidates(dataSearch, page))
            dispatch(alert({ msg: 'success_operation', type: 'success' }));
        },
        (err) => {
            dispatch(alert({ msg: 'failed_operation', type: 'error' }))
        }
        )
    }
};

const applyMission = (data, dataListing, page, setCenteredModal, onClose, jobTitle) => {
    const URL = API_HOST + API.candidature.applyCandidature;
    return async dispatch => (
        axiosServices.post(URL, data).then(
            (res) => {
                if (data.qualification) setCenteredModal(false)
                onClose()
                dispatch(getAllProposedCandidates(dataListing, page))
                dispatch(alert({ msg: 'success_apply_mission', signature: 'team_valjob', jobTitle: jobTitle, type: 'success' }));
            },
            (err) => {
                if (err.response.data.message === "candidature  already exists") dispatch(alert({ msg: 'candidature_exist', type: 'error' })); 
                else dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            }
        )
    )
}

const applyMissionPostulation = (data, title) => {
    const URL = API_HOST + API.candidature.applyCandidature;
    return async dispatch => (
        axiosServices.post(URL, data).then(
            (res) => {
                dispatch(alert({ msg: 'success_apply_mission', signature: 'team_valjob', jobTitle: title, redirectLink: 'access_account', type: 'success' }));
            },
            (err) => {
                if (err.response.data.message === "candidature  already exists") dispatch(alert({ msg: 'candidature_exist', type: 'error' })); 
                else dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            }
        )
    )
}

export { applyMissionPostulation, getAllCandidatures, getAllProposedCandidates, cancelCandidature, handlingNotinterrested, applyMission };